module.exports = __webpack_public_path__ + "img/7.b35e5159.png";